import { Card, CardContent } from "@/components/ui/card";
import { Users, Shield, Activity } from "lucide-react";

export const StatsCards = ({ users }) => {
  const activeCount = users.filter(u => u.is_active !== false).length;
  const totalEntries = users.reduce((sum, u) => sum + (u.entry_count || 0), 0);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      <Card className="border-border/50">
        <CardContent className="p-4 flex items-center gap-3">
          <Users className="w-8 h-8 text-primary" />
          <div>
            <div className="text-2xl font-mono font-bold" data-testid="stats-total-users">{users.length}</div>
            <div className="text-xs text-muted-foreground">Total Users</div>
          </div>
        </CardContent>
      </Card>
      <Card className="border-border/50">
        <CardContent className="p-4 flex items-center gap-3">
          <Shield className="w-8 h-8 text-green-500" />
          <div>
            <div className="text-2xl font-mono font-bold" data-testid="stats-active-users">{activeCount}</div>
            <div className="text-xs text-muted-foreground">Active</div>
          </div>
        </CardContent>
      </Card>
      <Card className="border-border/50">
        <CardContent className="p-4 flex items-center gap-3">
          <Activity className="w-8 h-8 text-blue-500" />
          <div>
            <div className="text-2xl font-mono font-bold" data-testid="stats-total-entries">{totalEntries}</div>
            <div className="text-xs text-muted-foreground">Total Entries</div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
